import React from 'react'
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import './Media.css'
const Mediaicons = () => {
    const icons = [
        {
            icon: <FaFacebook className='fb-icon' />
        },
        {
            icon: <FaXTwitter className='twitter-icon' />
        },
        {
            icon: <FaInstagram className='instgram-icon' />
        },
    ]

    return (
        <>
          
                <div className="media-icons">
                
                    {icons.map((icon,index) => {
                        return <span key={index} className='pe-3 fs-2' style={{cursor:'pointer'}}>{icon.icon}</span>
                    })}
                </div>
         
        </>
    )
}

export default Mediaicons